/**
 * Renders a schema.org JSON-LD structured data block.
 *
 * JSON-LD is used instead of microdata/RDFa because Google recommends it and
 * it keeps structured data decoupled from markup. Google's documentation
 * explicitly supports JSON-LD placement anywhere in `<head>` or `<body>`, so
 * rendering inline within a component is valid.
 *
 * `dangerouslySetInnerHTML` is required because React escapes `<script>` content
 * by default; the JSON payload contains no user-supplied input so XSS is not a risk.
 *
 * @param data - A schema.org object, e.g. `{ "@type": "FAQPage", ... }`.
 */
export default function JsonLd({ data }: { data: object }) {
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
        />
    );
}
